import React from 'react';
import parse from 'html-react-parser';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Placement } from 'react-bootstrap/esm/types';
import Tooltip from 'react-bootstrap/Tooltip';

interface Props {
  children: any;
  className?: string;
  id: string;
  body: string;
  closeButton?: boolean;
  rootClose?: boolean;
  trigger?: 'hover' | 'click' | 'focus' | Array<'hover' | 'click' | 'focus'>;
  placement?: Placement;
}
function TooltipECS({ children, ...restProps }: Props): JSX.Element {
  const classN = restProps.className || '';
  const toShowCloseBtn =
    typeof restProps.closeButton !== 'undefined' ? restProps.closeButton : true;
  const trigger = restProps.trigger || ['click', 'hover'];
  const rootClose = typeof restProps.rootClose !== 'undefined' ? restProps.rootClose : true;
  const placement = restProps.placement || 'auto';
  return (
    <OverlayTrigger
      trigger={trigger}
      rootClose={rootClose}
      placement={placement}
      overlay={
        <Tooltip
          id={restProps.id}
          className={classN}>
          {toShowCloseBtn && (
            <button
              type="button"
              onClick={() => document.body.click()}
              className="btn pe-0 pt-0 ecs-font-icon-act-close text-white float-end"
              aria-label="Close the tooltip"
            />
          )}

          {parse(restProps.body)}
        </Tooltip>
      }>
      {children}
    </OverlayTrigger>
  );
}

export default TooltipECS;
